// @flow
import { createSelector } from 'reselect';

export const getSpotScheduleState = (state: any) => state.salesInventory;
export const getSpotSchedule = createSelector(getSpotScheduleState, s => s.spotSchedule);
export const hasTimeSlotModificationError = createSelector(getSpotScheduleState, s => Boolean(s.timeSlotModificationError));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesInventory/selectors/salesInventorySelectors.js